import { useState, useCallback } from 'react'
import { validateTaxNumber } from '@lmipro/services'

export const useTaxNumberValidation = () => {
    const [isValid, setIsValid] = useState(true)
    const [isValidating, setIsValidating] = useState(false)

    const validate = useCallback(
        async (country: string, taxNumber: string, federalTaxType?: string) => {
            setIsValidating(true)

            try {
                await validateTaxNumber(country, taxNumber, federalTaxType)
                setIsValid(true)
            } catch (e) {
                setIsValid(false)
            } finally {
                setIsValidating(false)
            }
        },
        [setIsValid, setIsValidating]
    )

    return {
        validate,
        isValid,
        isValidating,
    }
}
